import React, { useEffect, useState, useContext } from "react";
import {
  ArrowLeftOutlined,
  PlusOutlined,
  TeamOutlined,
  SettingOutlined,
  BookOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import {
  Button,
  Tabs,
  Typography,
  Input,
  message,
  Spin,
  Popconfirm,
  Select,
  List,
  Table,
  Space,
  Tag,
} from "antd"; // Import Select and List
//import { Link, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import AddTask from "../Modals/AddTask";
import UpdateTask from "../Modals/UpdateTask";
import AuthContext from "../context/authContext";
import axios from "axios";
import { unloadUnityWebGL, unityContext } from "../context/unityContext";
import record_selected from "../img/record_selected_64.png";
import authoring_selected from "../img/authoring_selected_64.png";
import read_aloud_selected from "../img/read_aloud_selected_64.png";
import word_clarification_selected from "../img/word_clarification_selected_64.png";
import word_wall_selected from "../img/word_wall_selected_64.png";
import { taskRegistry } from "../config/taskRegistry";
import { reflectionForms } from "../config/reflectionForms";

const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { Column } = Table;

const Group = ({ group: passedGroup, onBack }) => {
  //const { id } = useParams(); // Get group ID from URL
  //const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [users, setUsers] = useState([]); // List of all users
  const [existingMembers, setExistingMembers] = useState([]); // Existing members of the group
  const [selectedUser, setSelectedUser] = useState(null); // Selected user to add

  const [stories, setStories] = useState([]); // List of stories
  const [selectedStory, setSelectedStory] = useState(null); // Chosen story
  const [characters, setCharacters] = useState([]); // Characters of selected story
  const [members, setMembers] = useState([]); // Group members
  const [assignments, setAssignments] = useState({}); // Character -> Member mapping
  const [allAssignments, setAllAssignments] = useState({});

  const [showTaskForm, setShowTaskForm] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);
  const [editingTaskId, setEditingTaskId] = useState(null);
  const [charactersByStory, setCharactersByStory] = useState({});
  const [existingTasksByStory, setExistingTasksByStory] = useState({});

  const { currentUser } = useContext(AuthContext);
  const [isOwner, setIsOwner] = useState(false);

  const id = passedGroup?.id;

  useEffect(() => {
    if (unityContext) unloadUnityWebGL();
    if (!id) return;
    const fetchGroups = async () => {
      try {
        let response;
        if (currentUser.role === 0) {
          setIsOwner(true);
        } else {
          // Normal users fetch groups they belong to
          console.log("normal user get group!!");
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
        message.error("Beim Abrufen der Gruppen ist ein Fehler aufgetreten.");
      }
    };
    fetchGroups();
  }, [currentUser.id, currentUser.role]);

  useEffect(() => {
    // Fetch all stories when component loads
    axios.get("/api/stories").then((res) => setStories(res.data));
  }, []);

  const allCharactersCategories = new Set(["hexiLexi", "vorlesen", "analyze"]);
  const taskRequiresCharacter = (category) =>
    !allCharactersCategories.has(category);

  const getDescriptionText = (taskKey, descriptionId) => {
    // Normal tasks
    const task = taskRegistry?.[taskKey];
    if (task && task.descriptions) {
      const desc = task.descriptions.find((d) => d.id === descriptionId);
      if (desc) return desc.text;
    }

    // Reflection tasks
    const reflection = reflectionForms?.[taskKey];
    if (reflection) {
      return reflection.description;
    }

    return descriptionId || "Keine Beschreibung";
  };

  const ensureCharactersForStory = async (storyId) => {
    if (!storyId) return;
    if (charactersByStory[storyId]) return;
    try {
      const res = await axios.get(`/api/characters/?storycharid=${storyId}`);
      setCharactersByStory((prev) => ({ ...prev, [storyId]: res.data }));
    } catch (error) {
      console.error("Error fetching story characters:", error);
      message.error("Fehler beim Abrufen der Charaktere.");
    }
  };

  const ensureExistingTasksForStory = async (storyId) => {
    if (!storyId) return;
    if (existingTasksByStory[storyId]) return;
    try {
      const res = await axios.get(`/api/tasks/${id}/${storyId}`);
      setExistingTasksByStory((prev) => ({ ...prev, [storyId]: res.data }));
    } catch (error) {
      console.error("Error fetching existing tasks:", error);
      message.error("Fehler beim Laden der Aufgaben.");
    }
  };

  const getAvailableCharactersForRow = (record, storyCharacters) => {
    const storyId = record?.story;
    const storyTasks = existingTasksByStory[storyId] || [];

    // Only exclude characters already used by other tasks of the same category
    const usedByOtherTasks = new Set(
      storyTasks
        .filter(
          (t) =>
            t.category === record.task &&
            Number(t.task_id) !== Number(record.taskId)
        )
        .flatMap((t) =>
          t.character_ids ? t.character_ids.split(",").map(Number) : []
        )
        .filter((n) => !Number.isNaN(n))
    );

    // Always keep currently assigned character available
    if (record.characterId !== null && record.characterId !== undefined) {
      usedByOtherTasks.delete(Number(record.characterId));
    }

    return storyCharacters.filter((c) => !usedByOtherTasks.has(Number(c.id)));
  };

  const handleInlineCharacterChange = async (taskId, storyId, value) => {
    const nextCharacterId =
      value === "alles" || value === undefined ? null : Number(value);
    const previousCharacterId = allAssignments?.[taskId]?.characterId ?? null;

    setAllAssignments((prev) => {
      if (!prev?.[taskId]) return prev;
      return {
        ...prev,
        [taskId]: {
          ...prev[taskId],
          characterId: nextCharacterId,
        },
      };
    });

    try {
      await axios.put(`/api/tasks/${taskId}/character`, {
        characterId: nextCharacterId,
      });
      await ensureCharactersForStory(storyId);
      // Refresh task usage so availability filtering is up-to-date
      try {
        const tasksRes = await axios.get(`/api/tasks/${id}/${storyId}`);
        setExistingTasksByStory((prev) => ({
          ...prev,
          [storyId]: tasksRes.data,
        }));
      } catch (e) {
        // Non-blocking: filtering will update next time the dropdown opens
      }
      message.success("Charakterzuweisung aktualisiert.");
    } catch (error) {
      console.error("Error updating task character:", error);
      message.error("Fehler beim Aktualisieren des Charakters.");
      setAllAssignments((prev) => {
        if (!prev?.[taskId]) return prev;
        return {
          ...prev,
          [taskId]: {
            ...prev[taskId],
            characterId: previousCharacterId,
          },
        };
      });
    }
  };

  useEffect(() => {
    if (selectedStory) {
      // Fetch characters for the selected story
      axios
        .get(`/api/characters/?storycharid=${selectedStory}`)
        .then((response) => {
          setCharacters(response.data);
        })
        .catch((error) => {
          console.error("Error fetching characters:", error);
        });

      // ✅ Fetch assigned tasks for the selected story
      axios
        .get(`/api/tasks/${selectedStory}/tasks`)
        .then((res) => {
          console.log("Fetched tasks:", res.data);
          const tasks = res.data;
          const formattedTasks = {};

          // Format tasks based on the new structure
          tasks.forEach((task) => {
            // If the task has an associated character
            if (task.characterId) {
              if (!formattedTasks[task.characterId]) {
                formattedTasks[task.characterId] = {
                  id: task.id,
                  member: task.member_id,
                  task: task.category,
                  description: task.description,
                  characterId: task.characterId, // Include characterId for reference
                };
              }
            } else {
              // Handle tasks without characters (if applicable)
              if (!formattedTasks["noCharacter"]) {
                formattedTasks["noCharacter"] = [];
              }
              formattedTasks["noCharacter"].push({
                id: task.id,
                member: task.member_id,
                task: task.category,
                description: task.description,
              });
            }
          });
          console.log("formattedTasks:", formattedTasks);
          setAssignments(formattedTasks);
        })
        .catch((error) => console.error("Error fetching tasks:", error));
    }
  }, [selectedStory]); // Runs when selectedStory changes

  useEffect(() => {
    console.log(">>>>>>>>>>>>>>>>allAssignments", allAssignments);
    console.log(
      ">>>>>>>>>>>>>>>Object.keys(allAssignments).length",
      Object.keys(allAssignments).length
    );
    if (allAssignments && Object.keys(allAssignments).length > 0) {
      const characterIds = [
        ...new Set(
          Object.values(allAssignments)
            .map((task) => task.characterId)
            .filter(Boolean)
        ),
      ];

      if (characterIds.length > 0) {
        console.log("Triggering character fetch for IDs:", characterIds);
        fetchCharactersByIds(characterIds);
      } else {
        setCharacters([]);
      }
    }
  }, [allAssignments]); // Re-run when allAssignments updates

  useEffect(() => {
    if (!showTaskForm || !isUpdateModalVisible) {
      if (currentUser && currentUser.id) {
        fetchTasks();
      }
    }
  }, [showTaskForm, isUpdateModalVisible, currentUser]);

  const StoryOptionLabel = ({ text, imgSrc, iconStyle, fallbackIcon }) => {
    const [imgError, setImgError] = useState(false);
    const hasImg = Boolean(imgSrc) && !imgError;

    useEffect(() => {
      setImgError(false);
    }, [imgSrc]);

    return (
      <Space
        align="center"
        size={8}
        style={{ maxWidth: "100%", display: "flex" }}
      >
        {hasImg ? (
          <img
            src={imgSrc}
            alt={""}
            style={{
              ...iconStyle,
              display: "block",
              flex: iconStyle?.width ? `0 0 ${iconStyle.width}px` : "0 0 auto",
            }}
            onError={() => setImgError(true)}
          />
        ) : (
          fallbackIcon || (
            <FileImageOutlined
              style={{ fontSize: 20, color: "rgba(0,0,0,0.45)" }}
            />
          )
        )}
        <span
          style={{
            flex: "1 1 auto",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </span>
      </Space>
    );
  };
  const fetchTasks = async () => {
    await axios
      .get(`/api/groups/${id}/members`)
      .then((res) => setMembers(res.data))
      .catch((error) => console.error("Error fetching groups:", error));

    // Fetch all assigned tasks for the group

    let url;

    if (currentUser.role === 0) {
      // Fetch all tasks for the group
      url = `/api/tasks/groups/${id}/tasks`;
    } else {
      // Fetch only tasks assigned to the logged-in user
      if (currentUser) {
        url = `/api/tasks/users/${currentUser.id}/groups/${id}/tasks`;
      }
    }

    await axios
      .get(url)
      .then((res) => {
        console.log("Fetched ALL tasks:", res.data);
        const tasks = res.data;
        const formattedTasks = {};

        tasks.forEach((task) => {
          formattedTasks[task.task_id] = {
            taskId: task.task_id,
            story: task.story_id,
            member: task.member_id,
            task: task.category,
            description: task.description,
            status: task.status,
            characterId: task.character_id,
          };
        });

        console.log("formattedTasks:", formattedTasks);
        setAllAssignments(formattedTasks);
      })
      .catch((error) => console.error("Error fetching tasks:", error));
  };

  const fetchCharactersByIds = async (characterIds) => {
    console.log("Fetching characters for IDs:", characterIds); // Log before API call
    try {
      const response = await axios.get(`/api/characters`, {
        params: { ids: characterIds.join(",") },
      });
      console.log("API Response:", response.data); // Log API response
      setCharacters(response.data);
    } catch (error) {
      console.error("Error fetching characters:", error);
    }
  };

  useEffect(() => {
    console.log("Updated characters:", characters);
  }, [characters]); // Runs when characters state updates

  useEffect(() => {
    const fetchGroup = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await axios.get(`/api/groups/${id}`);
        console.log("Groups response:", response);

        setGroup(response.data);
        // Fetch existing members
        const membersResponse = await axios.get(`/api/groups/${id}/members`);
        console.log("Members response:", membersResponse);

        setExistingMembers(membersResponse.data);
      } catch (error) {
        console.error("Error fetching group:", error);
        message.error("Fehler beim Abrufen der Gruppe.");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    const fetchUsers = async () => {
      // TODO: update this function to only fetch users in the group
      try {
        const response = await axios.get("/api/users"); // Fetch all users
        console.log("Users response:", response);

        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
        message.error("Fehler beim Abrufen der Benutzer.");
      }
    };
    fetchGroup();
    fetchUsers();
  }, [id]);

  const handleAddUser = async () => {
    if (!selectedUser) {
      message.error("Bitte wähle einen Benutzer aus.");
      return;
    }

    try {
      await axios.post(`/api/groups/${id}/members`, { userId: selectedUser });
      message.success("Benutzer wurde zur Gruppe hinzugefügt.");

      // Refresh the members list to update the UI
      const membersResponse = await axios.get(`/api/groups/${id}/members`);
      setExistingMembers(membersResponse.data);

      // Reset the selected user
      setSelectedUser(undefined); // Explicitly resetting selection  // This clears the Select component
      message.success("setSelectedUser null");
    } catch (error) {
      console.error("Error adding user:", error);
      message.error("Fehler beim Hinzufügen des Benutzers zur Gruppe.");
    }
  };

  const handleRemoveUser = async (userId) => {
    try {
      await axios.delete(`/api/groups/${id}/members/${userId}`);
      message.success("Benutzer wurde aus der Gruppe entfernt.");

      // Refresh existing members list
      const membersResponse = await axios.get(`/api/groups/${id}/members`);
      setExistingMembers(membersResponse.data);
    } catch (error) {
      console.error("Error removing user:", error);
      message.error("Fehler beim Entfernen des Benutzers.");
    }
  };

  const handleDelete = async () => {
    try {
      await axios.delete(`/api/groups/${id}`);
      message.success("Gruppe erfolgreich gelöscht.");
      //navigate("/groups"); // Navigate back to groups list after deletion
      if (onBack) {
        onBack(); // Go back to group list
      }
    } catch (error) {
      console.error("Error deleting group:", error);
      message.error("Fehler beim Löschen der Gruppe.");
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`/api/groups/${id}`, {
        name: group.name,
        color: group.color,
      });
      message.success("Gruppe erfolgreich aktualisiert.");
    } catch (error) {
      console.error("Error updating group:", error);
      message.error("Fehler beim Aktualisieren der Gruppe.");
    }
  };

  const handleAssignMember = (characterId, memberId) => {
    axios
      .post(`/api/stories/${selectedStory}/characters/${characterId}/assign`, {
        memberId,
      })
      .then(() => {
        setAssignments((prev) => ({ ...prev, [characterId]: memberId }));
        message.success("Mitglied erfolgreich zugewiesen!");
      })
      .catch(() => {
        message.error("Fehler beim Zuweisen des Mitglieds.");
      });
  };

  const handleAssignTask = (characterId, memberId, taskType, description) => {
    if (!characterId || !memberId || !taskType || !description) {
      message.error("Bitte füllen Sie alle Felder aus.");
      return;
    }

    console.log("group id:", id);
    axios
      .post(`/api/tasks/${selectedStory}/characters/${characterId}/assign`, {
        memberId,
        id, // Ensure this is defined
        category: taskType,
        description,
      })
      .then((response) => {
        const newTaskId = response.data.taskId; // Get new task ID

        setAssignments((prev) => ({
          ...prev,
          [characterId]: {
            id: newTaskId, // Store the task ID
            member: memberId,
            task: taskType,
            description,
          },
        }));

        message.success("Aufgabe erfolgreich zugewiesen!");
      })
      .catch((error) => {
        console.error("Error assigning task:", error);
        message.error("Fehler beim Zuweisen der Aufgabe.");
      });
  };

  const handleDeassignTask = async (taskId) => {
    try {
      console.log("taskId:::", taskId);
      await axios.delete(`/api/tasks/${taskId}`);

      setAllAssignments((prev) => {
        const updatedAssignments = { ...prev };
        delete updatedAssignments[taskId]; // Remove the task from state
        return updatedAssignments;
      });

      message.success("Aufgabe erfolgreich gelöscht!");

      fetchTasks();
    } catch (error) {
      message.error("Fehler beim Löschen der Aufgabe.");
    }
  };

  const handleEditTask = (task) => {
    setTaskToEdit(task);
    const nextTaskId = task?.taskId ?? null;
    setEditingTaskId((prev) => (prev === nextTaskId ? null : nextTaskId));
    // Keep modal closed; inline edit happens directly in the table.
    setIsUpdateModalVisible(false);
    if (task?.story) {
      ensureCharactersForStory(task.story);
      ensureExistingTasksForStory(task.story);
    }
  };

   if (loading) { return <Spin size="large" className="loader" />;  }

  const updateTasksState = (task_Id) => {
    setAllAssignments((prev) => {
      const updatedAssignments = { ...prev };
      delete updatedAssignments[task_Id]; // Remove the task from state
      return updatedAssignments;
    });
  };

  const handleToggleTaskCompletion = async (taskId, currentStatus) => {
    // Determine the new status
    const newStatus = currentStatus === "completed" ? "pending" : "completed";

    try {
      // Make an API call to update the task status
      const response = await axios.put(`/api/tasks/${taskId}/status`, {
        status: newStatus,
      });

      // Optionally, you can handle the response here
      console.log(response.data.message); // e.g., "Task status updated successfully"
      fetchTasks();
      // Optionally, refresh the task list or update the state to reflect the change
      // For example, you might want to fetch the updated tasks again
    } catch (error) {
      console.error("Error updating task status:", error);
      // Handle the error (e.g., show a notification to the user)
    }
  };
  const taskTypeIconStyle = {
    width: 32,
    height: 32,
    objectFit: "contain",
  };

  const storyFilters = (stories || []).map((s) => ({
    text: s.title,
    value: s.id,
  }));

  const characterFilters = (characters || []).map((c) => ({
    text: c.name,
    value: c.id,
  }));

  const memberFilters = (members || []).map((m) => ({
    text: m.username,
    value: m.id,
  }));

  const taskFilters = [
    { text: "Aufnehmen", value: "record" },
    { text: "Feedback geben", value: "feedback" },
    { text: "Wortwolke", value: "analyze" },
    { text: "Gestalten", value: "enrichments" },
    { text: "HexiLexi", value: "hexiLexi" },
    { text: "Vorlesen", value: "vorlesen" },
    {
      text: "reflection_1 geschichte_neue-woerter",
      value: "1 geschichte_neue-woerter",
    },
  ];

  const statusFilters = [
    { text: "Fertig", value: "completed" },
    { text: "Unfertig", value: "pending" },
  ];
  return (
    <div style={{ padding: "20px", margin: "0", overflow: "auto" }}>
      {/* BACK BUTTON */}
      <Button
        icon={<ArrowLeftOutlined />}
        size="large"
        onClick={onBack}        
        style={{ marginBottom: 20 }}
      >
        Zurück zu Gruppen
      </Button>

      <Title className="title">{group ? group.name : ""}</Title>

      <Tabs defaultActiveKey="1" style={{ width: "100%" }}>
        {/* Task management */}

        <TabPane
          tab={
            <span>
              <BookOutlined style={{ fontSize: "24px" }} /> Inhalte
            </span>
          }
          key="1"
        >
          {isOwner && (
            <>
              <p>Hier kannst du Aufgaben zuweisen.</p>

              <Button
                icon={<PlusOutlined style={{ fontSize: "24px" }} />}
                type="primary"
                size="large"
                className="btn"
                onClick={() => setShowTaskForm(true)}
              >
                Aufgaben zuweisen
              </Button>

              <AddTask
                visible={showTaskForm}
                onClose={() => {
                  setShowTaskForm(false);
                  updateTasksState(id);
                }}
                id={id}
                StoryOptionLabel={StoryOptionLabel}
              />

              <UpdateTask
                visible={isUpdateModalVisible}
                onClose={() => {
                  setIsUpdateModalVisible(false);
                  setEditingTaskId(null);
                  updateTasksState(id);
                }}
                id={id} // Ensure group ID is available
                taskToEdit={taskToEdit}
              />
            </>
          )}

          <p>Dies ist eine übersicht über deine Aufgaben.</p>

          {/* Table to Assign Tasks */}
          <Space style={{ overflow: "auto" }}>
            <Table
              dataSource={Object.values(allAssignments)} // Convert the object to an array
              rowKey="taskId" // Use task ID as the unique key
              pagination={false}
            >
              <Column
                title="Geschichte"
                dataIndex="story"
                key="story"
                filters={storyFilters}
                filterSearch
                onFilter={(value, record) =>
                  Number(record.story) === Number(value)
                }
                render={(text, record) => (
                  <span>
                    {stories.find((story) => story.id === record.story)
                      ?.title || "Unbekannt"}
                  </span>
                )}
              />

              <Column
                title="Charakter"
                dataIndex="characterId"
                key="characterId"
                filters={characterFilters}
                filterSearch
                onFilter={(value, record) =>
                  Number(record.characterId) === Number(value)
                }
                render={(text, record) => {
                  const isEditingThisRow =
                    isOwner && editingTaskId === record.taskId;
                  const storyId = record.story;
                  const storyCharacters = charactersByStory[storyId] || [];

                  if (isEditingThisRow) {
                    const availableCharacters = getAvailableCharactersForRow(
                      record,
                      storyCharacters
                    );
                    return (
                      <Select
                        style={{ minWidth: 220 }}
                        placeholder="Charakter auswählen"
                        value={
                          record.characterId === null ||
                          record.characterId === undefined
                            ? "alles"
                            : Number(record.characterId)
                        }
                        onDropdownVisibleChange={(open) => {
                          if (open) {
                            ensureCharactersForStory(storyId);
                            ensureExistingTasksForStory(storyId);
                          }
                        }}
                        onChange={(value) =>
                          handleInlineCharacterChange(
                            record.taskId,
                            storyId,
                            value
                          )
                        }
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        <Option value="alles">Alles</Option>
                        {availableCharacters.map((c) => (
                          <Option key={c.id} value={c.id}>
                            {c.name}
                          </Option>
                        ))}
                      </Select>
                    );
                  }

                  const normalizedCharacterId =
                    record.characterId === null ||
                    record.characterId === undefined
                      ? null
                      : Number(record.characterId);

                  const character =
                    characters.find(
                      (char) => Number(char.id) === normalizedCharacterId
                    ) ||
                    storyCharacters.find(
                      (char) => Number(char.id) === normalizedCharacterId
                    );

                  const missingRequiredCharacter =
                    record.task &&
                    taskRequiresCharacter(record.task) &&
                    !record.characterId;

                  return (
                    <Space size={8}>
                      <span>{character ? character.name : "Alles"}</span>
                      {missingRequiredCharacter && (
                        <Tag color="warning">Kein Charakter</Tag>
                      )}
                    </Space>
                  );
                }}
              />

              {/* Select Task Type */}
              <Column
                title="Aufgabe"
                key="taskType"
                filters={taskFilters}
                filterSearch
                onFilter={(value, record) => record.task === value}
                render={(text, record) => (
                  <span>
                    {record.task === "record" && (
                      <StoryOptionLabel
                        text="Aufnehmen"
                        imgSrc={record_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}
                    {record.task === "feedback" && (
                      <StoryOptionLabel
                        text="Feedback geben"
                        iconStyle={taskTypeIconStyle}
                        fallbackIcon={
                          <span style={{ fontSize: 18, lineHeight: 1 }}>✏</span>
                        }
                      />
                    )}
                    {record.task === "analyze" && (
                      <StoryOptionLabel
                        text="Wortwolke"
                        imgSrc={word_wall_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}
                    {record.task === "enrichments" && (
                      <StoryOptionLabel
                        text="Gestalten"
                        imgSrc={authoring_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}
                    {record.task === "hexiLexi" && (
                      <StoryOptionLabel
                        text="HexiLexi"
                        imgSrc={word_clarification_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}
                    {record.task === "vorlesen" && (
                      <StoryOptionLabel
                        text="Vorlesen"
                        imgSrc={read_aloud_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}

                    {record.task === "reflection_1 geschichte_neue-woerter" && (
                      <StoryOptionLabel
                        text="reflection_1 geschichte_neue-woerter"
                        imgSrc={read_aloud_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}

                    {record.task ===
                      "reflection_2 gestalten_bild-verbesserung" && (
                      <StoryOptionLabel
                        text="reflection_2 gestalten_bild-verbesserung"
                        imgSrc={read_aloud_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}

                    {record.task ===
                      "reflection_3 lesefluessigkeit_lesetheater" && (
                      <StoryOptionLabel
                        text="reflection_3 lesefluessigkeit_lesetheater"
                        imgSrc={read_aloud_selected}
                        iconStyle={taskTypeIconStyle}
                      />
                    )}

                    {!record.task && "Keine Aufgabe"}
                  </span>
                )}
              />
              {/* Task Description */}
              <Column
                title="Beschreibung"
                key="taskDescription"
                render={(text, record) => (
                  <span>
                    {record.description
                      ? getDescriptionText(record.task, record.description)
                      : "Keine Beschreibung"}
                  </span>
                )}
              />
              {/* Assign Member */}
              <Column
                title="Mitglied"
                key="assignedMember"
                filters={memberFilters}
                filterSearch
                onFilter={(value, record) =>
                  Number(record.member) === Number(value)
                }
                render={(text, record) => {
                  const member = members.find((m) => m.id === record.member);
                  return <span>{member ? member.username : "Unbekannt"}</span>;
                }}
              />
              {/* Status */}
              <Column
                title="Status"
                key="state"
                filters={statusFilters}
                filterSearch
                onFilter={(value, record) => record.status === value}
                render={(text, record) => {
                  // Define a style object based on the status
                  const cellStyle = {
                    backgroundColor:
                      record.status === "completed"
                        ? "lightgreen"
                        : record.status === "pending"
                        ? "lightcoral"
                        : "lightgray",
                    padding: "8px",
                    borderRadius: "4px",
                  };

                  return (
                    <div style={cellStyle}>
                      <Space>
                        <Button
                          type={
                            record.status === "completed"
                              ? "primary"
                              : "default"
                          }
                          onClick={() =>
                            handleToggleTaskCompletion(
                              record.taskId,
                              record.status
                            )
                          }
                          disabled={record.status === "completed"} // Disable if already completed
                          style={{ marginRight: "8px" }}
                        >
                          Fertig
                        </Button>
                        <Button
                          type={
                            record.status === "pending" ? "primary" : "default"
                          }
                          onClick={() =>
                            handleToggleTaskCompletion(
                              record.taskId,
                              record.status
                            )
                          }
                          disabled={record.status === "pending"} // Disable if already pending
                        >
                          Unfertig
                        </Button>
                      </Space>
                    </div>
                  );
                }}
              />

              {/* Assign Task Button */}
              {!isOwner && (
                <Column
                  title="Aktionen"
                  key="actions"
                  render={(text, record) => {
                    console.log("record:: ", record);

                    const isReflection = record.task.startsWith("reflection");

                    const route = isReflection
                      ? `/reflection/${record.taskId}/${record.task}`
                      : "/StoryReader";

                    return (
                      <Link
                        to={route}
                        state={{
                          storyId: record.story,
                          groupId: id,
                          taskCategory: record.task,
                        }}
                        className="link"
                      >
                        <Button type="primary" size="large" className="btn">
                          Mach die Aufgabe
                        </Button>
                      </Link>
                    );
                  }}
                />
              )}

              {/* Assign Task Button */}
              {isOwner && (
                <Column
                  title="Aktionen"
                  key="actions"
                  render={(text, record) => (
                    <>
                      {/* TODO: This button should enable the select dropdown to assign a character to the task if no character assigned yet */}
                      <Button
                        type="primary"
                        onClick={() => handleEditTask(record)}
                      >
                        {editingTaskId === record.taskId
                          ? "Speichern"
                          : "Rollentausch"}
                      </Button>

                      <Button
                        type="danger"
                        onClick={() => handleDeassignTask(record.taskId)}
                        style={{ marginLeft: "8px" }}
                      >
                        Löschen
                      </Button>
                    </>
                  )}
                />
              )}
            </Table>
          </Space>
        </TabPane>

        <TabPane
          tab={
            <span>
              <TeamOutlined style={{ fontSize: "24px" }} /> Mitglieder
            </span>
          }
          key="2"
        >
          {isOwner && (
            <>
              <p>Hier kannst du Mitglieder hinzufügen oder entfernen.</p>
              <Select
                placeholder="Benutzer auswählen"
                style={{ width: "200px", marginBottom: "10px" }}
                value={selectedUser || undefined} // Ensures the value resets
                onChange={(value) => setSelectedUser(value)}
              >
                {users
                  .filter(
                    (user) =>
                      !existingMembers.some((member) => member.id === user.id)
                  )
                  .map((user) => (
                    <Option key={user.id} value={user.id}>
                      <div style={{ color: "red" }}>{user.username}</div>
                    </Option>
                  ))}
              </Select>
              <Button
                type="primary"
                onClick={handleAddUser}
                style={{ marginLeft: "10px" }}
              >
                Hinzufügen
              </Button>
            </>
          )}
          <List
            header={<div>Bestehende Mitglieder</div>}
            bordered
            dataSource={existingMembers}
            renderItem={(member) => (
              <List.Item
                actions={[
                  <Popconfirm
                    title="Bist du sicher, dass du diesen Benutzer entfernen möchtest?"
                    onConfirm={() => handleRemoveUser(member.id)}
                    okText="Ja"
                    cancelText="Nein"
                  >
                    {isOwner && (
                      <Button danger size="small">
                        Löschen
                      </Button>
                    )}
                  </Popconfirm>,
                ]}
              >
                <div style={{ color: "red" }}>{member.username}</div>
              </List.Item>
            )}
            style={{ marginTop: "20px" }}
          />
        </TabPane>

        {isOwner && (
          <TabPane
            tab={
              <span>
                <SettingOutlined style={{ fontSize: "24px" }} /> Einstellungen
              </span>
            }
            key="3"
          >
            <p>Gruppe bearbeiten:</p>
            <Input
              value={group.name}
              onChange={(e) => setGroup({ ...group, name: e.target.value })}
              style={{ marginBottom: "10px", width: "100%" }} // Optional: Make input full width
            />
            <Input
              type="color"
              value={group.color}
              onChange={(e) => setGroup({ ...group, color: e.target.value })}
              style={{ width: "100px" }}
            />
            <Button
              type="primary"
              onClick={handleUpdate}
              style={{ marginRight: "10px" }}
            >
              Speichern
            </Button>
            <Popconfirm
              title="Bist du sicher, dass du diese Gruppe löschen möchtest?"
              onConfirm={handleDelete}
              okText="Ja"
              cancelText="Nein"
            >
              <Button danger style={{ marginLeft: "10px" }}>
                Löschen
              </Button>
            </Popconfirm>
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default Group;
